<template>
  <div class="quotation-detail">
    <!-- 操作栏 -->
    <div class="ctrl-bar">
      <div class="ctrl-bar-left">
        <span class="ctrl-title">排序：</span>
        <span
          v-for="(order, index) in orderByPropertyLists"
          :key="'order-'+index"
          @click="changeOrderType(order)"
          :class="{'order-item': true, 'active': order.value === orderByProperty}">
          {{ order.label }}
        </span>
      </div>
    </div>
    <!-- 卡片模式 -->
    <div>
      <!-- 维修 -->
      <CardDetailForMaintenance v-if="businessType === 'MAINTAIN'" :inquirePriceId="inquirePriceId" :orderByProperty="orderByProperty" :status="status" :quotePriceStatus="quotePriceStatus" :zgyFlag="zgyFlag" />
      <!-- 非维修 -->
      <CardDetailForNonMaintenance v-if="businessType === 'SPARE_PART'" :inquirePriceId="inquirePriceId" :orderByProperty="orderByProperty" :status="status" :quotePriceStatus="quotePriceStatus" :zgyFlag="zgyFlag" />
    </div>
  </div>
</template>
<script>
import CardDetailForMaintenance from './cardDetailForMaintenance.vue';
import CardDetailForNonMaintenance from './cardDetailForNonMaintenance.vue';
export default {
  props: {
    zgyFlag: {
      type: Boolean,
      default: true,
    },
    inquirePriceId: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    quotePriceStatus: {
      type: String,
      default: '',
    },
    businessType: {
      type: String,
      default: '',
    },
  },
  components: {
    CardDetailForMaintenance,
    CardDetailForNonMaintenance,
  },
  data () {
    return {
      orderByProperty: 'totalAmount',
      orderByPropertyLists: [
        {
          label: '价格优先',
          value: 'totalAmount',
        },
        {
          label: '交付优先',
          value: 'plannedDeliveryDate',
        },
        {
          label: '更新时间优先',
          value: 'lastUpdateTime',
        },
      ],
    };
  },
  methods: {
    changeOrderType (item) {
      this.orderByProperty = item.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.quotation-detail {
  .ctrl-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    margin-bottom: 8px;
    border-bottom: 1px solid #eee;
    .ctrl-bar-left {
      .ctrl-title {
        font-size: 14px;
        color: #909399;
      }
      .order-item {
        cursor: pointer;
        margin: 0 5px;
        padding: 4px 10px;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        font-size: 14px;
        color: #303133;
        &.active {
          border: 1px solid #0091FF;
          background: rgba(0, 145, 255, 0.05);
          font-weight: bold;
          color: #0091FF;
        }
      }
    }
  }
}
</style>
